import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@contexts/AuthContext';
import { ThemeProvider } from '@contexts/ThemeContext';
import ProtectedRoute from '@components/auth/ProtectedRoute';
import Layout from '@components/layout/Layout';

// Pages
import Login from '@pages/Login';
import Signup from '@pages/Signup';
import Dashboard from '@pages/Dashboard';
import Activity from '@pages/Activity';
import Nutrition from '@pages/Nutrition';
import Hydration from '@pages/Hydration';
import Weight from '@pages/Weight';
import Sleep from '@pages/Sleep';
import Habits from '@pages/Habits';
import Journal from '@pages/Journal';
import Achievements from '@pages/Achievements';
import FoodsManagement from '@pages/FoodsManagement';
import Settings from '@pages/Settings';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Protected routes */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="activity" element={<Activity />} />
              <Route path="nutrition" element={<Nutrition />} />
              <Route path="hydration" element={<Hydration />} />
              <Route path="weight" element={<Weight />} />
              <Route path="sleep" element={<Sleep />} />
              <Route path="habits" element={<Habits />} />
              <Route path="journal" element={<Journal />} />
              <Route path="achievements" element={<Achievements />} />
              <Route path="foods" element={<FoodsManagement />} />
              <Route path="settings" element={<Settings />} />
              <Route path="" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
